import * as React from "react";
import {Route, Switch} from "react-router-dom";
import {history} from "load/store";
import UserInputForm from "loan-application/application/userInputForm";
import Application from "loan-application/application/application";

export enum ApplicationRoute {
    USER_FORM = "/user-form",
}

export function getApplicationRoute(path: string) {
    // bad mounting of user form, TODO: beakish
    return (
        <Switch>
            <Route exact path={`${path}`} component={Application}/>
            <Route path={`${path}${ApplicationRoute.USER_FORM}`} component={UserInputForm}/>
        </Switch>
    );
}

export function handleApplicationNavigation(navigatePath: string, state?: object) {
    const obj: any = {pathname: navigatePath};
    if (state) {
        obj.state = state;
    }
    history.push(obj);
}
